module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Test user created","message":"You can now assign roles on this user."},"da":{"title":"Test brugere oprettet","message":"Du kan nu tildele roller til denne bruger."}}')
  delete Component.options._Ctor
}
